import React from 'react';
import styled from 'styled-components';

interface Props {
  text?: string;
}

export const Hint: React.FC<Props> = ({ text = 'Правильна відповдь' }) => {
  const [position, setPosition] = React.useState<{ x: number; y: number } | null>(null);

  React.useEffect(() => {
    document.addEventListener('mousemove', listener);
    return () => document.removeEventListener('mousemove', listener);
  }, []);

  const listener = (event: MouseEvent) => {
    const x = event.clientX - 50;
    const y = event.clientY - 70;
    setPosition({ x, y });
  };

  return (
    <div>
      {position ? (
        <HintS
          style={{
            top: `${position.y}px`,
            left: `${position.x}px`,
          }}
        >
          {text}
        </HintS>
      ) : null}
    </div>
  );
};

const HintS = styled.div`
  position: absolute;
  padding: 10px;
  background: white;
  border: 1px solid;
  color: black;
`;
